import React from 'react'
import PropTypes from 'prop-types'

import styles from './style.module.scss'
import CustomLink from '@shared/components/customLink'

const OverList = ({ data, id, is100 }) => {
  return (
    <section className={`${styles.overList} content-visibility-auto`} id={id}>
      <div className={`${styles.item} common-box d-flex align-items-start align-items-xl-center mb-3 `}>
        <div className={`${styles.over} mb-0 text-center common-box p-0 overflow-hidden`}>
          <p className={`${styles.overNo} mb-0 font-semi text-uppercase`}>{data?.sOver} {is100 ? 'B' : 'Over'}</p>
          <div className={`${styles.overRun} font-bold`}>{data?.nOverTotal} {'Runs'}</div>
        </div>
        <div className={`${styles.details} d-xl-flex`}>
          <div className={`${styles.balls} d-flex text-center scroll-list font-semi me-auto`}>
            {data?.aBall?.map((ball, index) => {
              return (
                <div className={`${styles.ball}`} key={index}>
                  {ball?.sScore === 'w' && <div className={`${styles.run} mb-2 rounded-pill redSix text-white`}>{ball?.sScore?.toUpperCase()}</div>}
                  {ball?.sScore === '4' && <div className={`${styles.run} mb-2 rounded-pill bg-success border-success text-white`}>{ball?.sScore}</div>}
                  {ball?.sScore === '6' && <div className={`${styles.run} mb-2 rounded-pill bg-success text-white`}>{ball?.sScore}</div>}
                  {ball?.sScore === '0' && <div className={`${styles.run} mb-2 rounded-pill`}>{ball?.sScore}</div>}
                  {(ball?.sScore === '4b' || ball?.sScore === '4lb') && <div className={`${styles.run} mb-2 rounded-pill`}>{ball?.sScore}</div>}
                  {(ball?.sScore !== 'w' && ((ball?.nRuns > 0 && ball?.nRuns < 4) || ball?.nRuns === 5 || ball?.nRuns > 6)) && <div className={`${styles.run} mb-2 rounded-pill`}>{ball?.sScore}</div>}
                  <span className="text-muted">{is100 ? `${ball?.sOver}` : `${ball?.sOver}.${ball?.sBall}`}</span>
                </div>
              )
            })}
          </div>
          <div className={`${styles.bowler}`}>
            {
              data?.oOver?.aBowlers[0]?.oBowler?.sFullName &&
              <p className="xsmall-text text-muted text-uppercase font-bold mb-0">{'Bowled by'}</p>
            }
            <p className="font-semi mb-0">
              <span className=" mb-2">{
                data?.oOver?.aBowlers[0]?.oBowler?.oSeo?.eStatus === 'a' && data?.oOver?.aBowlers[0]?.oBowler?.eTagStatus === 'a' ? (
                  <CustomLink href={`/${data?.oOver?.aBowlers[0]?.oBowler?.oSeo?.sSlug}`}>
                    {data?.oOver?.aBowlers[0]?.oBowler?.sFullName}
                  </CustomLink>
                ) : (
                  data?.oOver?.aBowlers[0]?.oBowler?.sFullName
                )
              }</span>
            </p>
          </div>
          <div className={`${styles.batter}`}>
            {
              (data?.oOver?.aBatters[0]?.oBatter?.sFullName || data?.oOver?.aBatters[1]?.oBatter?.sFullName) &&
              <p className="xsmall-text text-muted text-uppercase font-bold mb-0">{'Played by'}</p>
            }
            <p className="font-semi mb-0">
              <span>
                {
                  data?.oOver?.aBatters[0]?.oBatter?.oSeo?.eStatus === 'a' && data?.oOver?.aBatters[0]?.oBatter?.eTagStatus === 'a' ? (
                    <CustomLink href={`/${data?.oOver?.aBatters[0]?.oBatter?.oSeo?.sSlug}`}>{data?.oOver?.aBatters[0]?.oBatter?.sFullName}</CustomLink>
                  ) : (
                    data?.oOver?.aBatters[0]?.oBatter?.sFullName
                  )
                }
              </span>
              <span>{data?.oOver?.aBatters[1]?.oBatter?.oSeo?.eStatus === 'a' && data?.oOver?.aBatters[1]?.oBatter?.eTagStatus === 'a' ? (
                <CustomLink href={`/${data?.oOver?.aBatters[1]?.oBatter?.oSeo?.sSlug}`}>{`, ${data?.oOver?.aBatters[1]?.oBatter?.sFullName}`}</CustomLink>
              ) : (
                data?.oOver?.aBatters[1]?.oBatter?.sFullName && `, ${data?.oOver?.aBatters[1]?.oBatter?.sFullName}`
              )}</span>
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

OverList.propTypes = {
  data: PropTypes.object,
  id: PropTypes.string,
  is100: PropTypes.bool
}

export default OverList
